<template>
    <div class="container">
        <content-header title="Оформление справок"/>
        <img src="../../assets/images/staticPages/spravki-e1505229854410-300x186.png" alt="spravki" height="186"
             width="300" style="float: right; margin: 20px 0"/>
        <p class="bold">Кабинет платных медицинских услуг:</p>
        <p>Карасева Диана Геннадьевна</p>
        <p>✉ karaseva.d@5-clinic.ru</p>
        <p><strong>тел.</strong> 8 (495) 620-81-07;<br>
            <strong>тел.</strong> 8 (499) 248-49-38</p>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 1}" @click="selectTable(1)">
            <h3>Или оставив заявку на нашем сайте:</h3>
            <div class="plus" v-if="showTable !== 1">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 1">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <div v-if="showTable === 1">
                <static-page-contact-form></static-page-contact-form>
            </div>
        </transition>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 2}" @click="selectTable(2)">
            <h3>Прейскурант</h3>
            <div class="plus" v-if="showTable !== 2">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 2">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <prices-table v-if="showTable === 2" @sort="sortData" @pageChanged="currentPage" @scrollTop="scroll"
                          ref="scrollTo"
                          :data="priceAndServices"></prices-table>
        </transition>
        <div class="divider"></div>
        <div class="grid">
            <div class="box">
                <img src="../../assets/images/staticPages/checkup_SanKart-450x300.jpg" alt="checkup_SanKart"
                     width="225"/>
                <router-link :to="{name:'Санаторно курортная карта'}"
                             class="link"><span>САНАТОРНО-КУРОРТНАЯ КАРТА</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/otd_prof.png" alt="otd_prof" width="225"/>
                <router-link :to="{name:'Предварительные медосмотры'}"
                             class="link"><span>ПРЕДВАРИТЕЛЬНЫЕ МЕДОСМОТРЫ</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/spr_OsmAbit-450x300.jpg" alt="spr_OsmAbit" width="225"/>
                <router-link :to="{name:'Медосмотры абитуриентов'}"
                             class="link"><span>МЕДОСМОТРЫ АБИТУРИЕНТОВ</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/spr_vjd-450x300.png" alt="spr_vjd" width="225"/>
                <router-link :to="{name:'Для водителей'}"
                             class="link"><span>ДЛЯ ВОДИТЕЛЕЙ</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/galway-swimming-pool-membership-450x300.jpg"
                     alt="galway-swimming-pool-membership" width="225"/>
                <router-link :to="{name:'Справка в бассейн'}"
                             class="link"><span>СПРАВКА В БАССЕЙН</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/court-gavel-justice-450x300.jpg" alt="court-gavel-justice"
                     width="225"/>
                <router-link :to="{name:'Освидетельствование на должность судьи'}"
                             class="link"><span>ОСВИДЕТЕЛЬСТВОВАНИЕ НА ДОЛЖНОСТЬ СУДЬИ</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/gostaina.jpg" alt="gostaina" width="225"/>
                <router-link :to="{name:'Справка на гостайну'}"
                             class="link"><span>СПРАВКА НА ГОСТАЙНУ</span></router-link>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/crop-450x300.jpg" alt="crop" width="225"/>
                <router-link :to="{name:'Справка для поступающих на государственнуф службу'}"
                             class="link"><span>СПРАВКА ДЛЯ ПОСТУПАЮЩИХ НА ГОСУДАРСТВЕННУЮ СЛУЖБУ</span></router-link>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import ServiceAndPricesMixin from "../../mixins/ServiceAndPricesMixin";
import pricesTable from "@/components/pricesTable";
import StaticPageContactForm from "@/components/StaticPageContactForm";

export default {
    name: "registration",
    mixins: [ServiceAndPricesMixin],
    components: {
        ContentHeader,
        pricesTable,
        StaticPageContactForm
    },
    data() {
        return {
            showTable: false
        }
    },
    methods: {
        selectTable(id) {
            this.showTable = this.showTable === id ? null : id
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #006688;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 215px;
}

.box:first-child {
    margin: 0;
}

.grid {
    display: grid;
    grid-gap: 30px;
    grid-template-columns: repeat(auto-fill, 215px);
}

.link {
    color: black;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    margin: 5px auto;
}

.link > span {
    border-bottom: 1px dotted #006688;
}

.left-30px {
    margin-left: 30px;
}

.table-state {
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: sticky;

    &.open {
        padding: 10px 12px;
        background: #006688;
        color: white;
        margin-bottom: 20px;
    }

    h3 {
        font-size: 18px;
        font-weight: normal;
    }

    h3:hover {
        color: #3156A3;
    }

    &.open h3:hover {
        color: white;
    }

    @media screen and (max-width: 510px) {
        font-size: 11px;
    }
    @media screen and (max-width: 768px) {
        top: 0;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .4s, max-height .6s;
    max-height: 1000px;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
}

</style>
